import * as React from 'react';
import { SVGProps } from 'react';

const SvgMeetOurTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M25.579 20.915a5.882 5.882 0 0 1 4.148-1.722h1.277a5.89 5.89 0 0 1 4.149 1.722 5.889 5.889 0 0 1 1.722 4.153v3.204H35.35v-3.204a4.366 4.366 0 0 0-1.273-3.07 4.358 4.358 0 0 0-3.066-1.274h-1.277a4.358 4.358 0 0 0-3.067 1.273l-1.09-1.082Zm8.574-5.145-.749-.205a11.43 11.43 0 0 0-6.088 0l-.749.206-1.187-4.422.75-.202a16.127 16.127 0 0 1 8.472.007l.749.203-1.198 4.414Zm-6.886-3.324.375 1.457a13.024 13.024 0 0 1 5.406 0l.375-1.457a14.48 14.48 0 0 0-6.186 0h.03Z"
    />
    <path fill="currentColor" d="M32.846 22.559h-1.531v4.598h1.531v-4.598Z" />
    <path
      fill="currentColor"
      d="M34.382 24.09h-4.598v1.535h4.598V24.09Zm-4.007-3.366a4.036 4.036 0 0 1-4.036-4.032v-1.97h1.535v1.97a2.484 2.484 0 0 0 .749 1.767 2.501 2.501 0 0 0 1.767.749 2.486 2.486 0 0 0 1.767-.749 2.502 2.502 0 0 0 .75-1.767v-1.97h1.534v1.97a4.04 4.04 0 0 1-4.036 4.032h-.03Zm-7.379 4.864a1.535 1.535 0 0 0 1.082-2.618 1.531 1.531 0 0 0-2.167 0c-.287.287-.45.676-.45 1.083a1.539 1.539 0 0 0 1.535 1.535Zm-3.048.862H18.03v-1.536h.374v-.951a.798.798 0 0 0-.225-.543.783.783 0 0 0-.543-.225.783.783 0 0 0-.542.225.783.783 0 0 0-.225.543v.951h.352v1.535H15.35v-2.486a2.298 2.298 0 0 1 4.598 0v2.486Z"
    />
    <path
      fill="currentColor"
      d="M23.774 19.17h-1.527v4.471h1.53l-.003-4.47Zm-5.361-.097H16.88v2.88h1.532v-2.88Z"
    />
    <path
      fill="currentColor"
      d="M14.215 28.295h-1.53v-3.662a6.923 6.923 0 0 1 2.02-4.867 6.92 6.92 0 0 1 4.868-2.022h1.55a6.92 6.92 0 0 1 4.868 2.022 6.919 6.919 0 0 1 2.022 4.867v3.636H26.48v-3.636a5.395 5.395 0 0 0-1.572-3.793 5.395 5.395 0 0 0-3.793-1.572h-1.532a5.395 5.395 0 0 0-3.792 1.572 5.395 5.395 0 0 0-1.573 3.793l-.004 3.662Z"
    />
    <path
      fill="currentColor"
      d="M20.345 19.257a4.703 4.703 0 0 1-4.331-2.898 4.677 4.677 0 0 1-.357-1.794V12.2h1.531v2.366a3.153 3.153 0 0 0 1.956 2.933c.386.159.799.24 1.216.238a3.153 3.153 0 0 0 2.934-1.955c.16-.386.241-.799.24-1.216V12.2h1.532v2.366a4.677 4.677 0 0 1-1.374 3.314 4.714 4.714 0 0 1-3.317 1.378h-.03Z"
    />
    <path
      fill="currentColor"
      d="M25.036 14.558h-1.531v-2.363a3.165 3.165 0 0 0-.925-2.246 3.164 3.164 0 0 0-2.247-.925 3.16 3.16 0 0 0-3.171 3.171v2.363h-1.531v-2.363a4.687 4.687 0 0 1 1.374-3.317A4.703 4.703 0 0 1 20.318 7.5a4.706 4.706 0 0 1 4.335 2.9c.236.569.357 1.179.357 1.795l.026 2.363ZM9.715 25.318l-4.557-4.56 1.019-1.018 3.538 3.538 3.538-3.538 1.019 1.018-4.557 4.56Z"
    />
    <path
      fill="currentColor"
      d="M14.01 21.432a5.047 5.047 0 0 0-3.569-1.479H9a5.035 5.035 0 0 0-3.565 1.479 5.032 5.032 0 0 0-1.479 3.564v3.299H2.515v-3.287a6.474 6.474 0 0 1 1.902-4.583A6.48 6.48 0 0 1 9 18.523h1.441c1.72 0 3.37.683 4.587 1.898"
    />
    <path
      fill="currentColor"
      d="M9.708 19.934A4.414 4.414 0 0 1 6.6 18.64a4.4 4.4 0 0 1-1.296-3.108v-2.224h1.442v2.224a2.97 2.97 0 0 0 5.062 2.097c.558-.556.874-1.31.88-2.097v-2.224h1.441v2.224a4.406 4.406 0 0 1-1.303 3.115 4.425 4.425 0 0 1-3.118 1.288Z"
    />
    <path
      fill="currentColor"
      d="M14.13 15.512h-1.442V12.48c0-.573-.228-1.122-.633-1.528a2.179 2.179 0 0 0-1.531-.633H8.906a2.164 2.164 0 0 0-2.16 2.16v3.034H5.304V12.48A3.613 3.613 0 0 1 6.36 9.934a3.613 3.613 0 0 1 2.546-1.056h1.618c.956 0 1.873.38 2.55 1.056a3.628 3.628 0 0 1 1.055 2.546v3.032Z"
    />
    <path
      fill="currentColor"
      d="M13.193 13.846a13.135 13.135 0 0 0-6.956 0l-.375-1.389a14.6 14.6 0 0 1 7.724 0l-.393 1.39Z"
    />
    <path
      fill={props.fill}
      d="M36.871 28.269v3.048H5.536L2.5 28.277l34.371-.008Z"
    />
  </svg>
);

export default SvgMeetOurTeam;
